// extracted by mini-css-extract-plugin
module.exports = {"inputForm":"Input_inputForm__3mEb2","customInput":"Input_customInput__3udhs","customLabel":"Input_customLabel__3os2E"};